import { downloadExport } from "./exportDownload";

/** Maps entity table names to their wizard stage number.
 *
 * StageChannelModifiers (5) was inserted between Banks and LiftsFloors,
 * shifting every later stage by +1. Source of truth:
 * LiftCloud/utils/wizexport/types.go. */
const entityStageMap: Record<string, number> = {
  organizations: 0,
  servers: 1,
  adapters: 2,
  keys: 2,
  channels: 3,
  banks: 4,
  channel_modifiers: 5,
  lifts: 6,
  bacnet_points: 7,
  roles: 8,
  users: 8,
  notifications: 9,
  action_catalogs: 10,
  monitor_grids: 11,
  timed_actions: 12,
};

/**
 * Downloads an entity's stage as a .lnx (FlatBuffer binary) file via the
 * backend stage export endpoint. The backend handles FlatBuffer serialization
 * with size-prefix, LN2E envelope, and schema hash verification.
 *
 * Since the binary export uses the OrgExport schema (which is stage-based),
 * this exports the full stage containing the entity rather than a single row.
 */
export default async function downloadEntityAsBinary(
  orgId: string,
  tableName: string,
  entityName?: string,
  adapterId?: string,
): Promise<void> {
  const stage = entityStageMap[tableName];
  if (stage === undefined) {
    throw new Error(`Unknown entity table: ${tableName}`);
  }

  await downloadExport({
    orgId,
    stage,
    includeDeps: false,
    entityName,
    adapterId,
  });
}
